// Tabla "Por línea de negocio" para los PDF ejecutivos de dashboards.
// columns: [{ header, width, align, bold, value: (row) => string }]
export function lineBreakdownSection({ title, columns, rows, selectedName }) {
  if (!rows || !rows.length) return []
  const header = columns.map((col) => ({
    text: col.header,
    fontSize: 7,
    bold: true,
    color: '#64748B',
    fillColor: '#F8FAFC',
    alignment: col.align || 'left'
  }))
  const body = rows.map((row) => {
    const selected = row.name === selectedName
    return columns.map((col, index) => ({
      text: col.value(row),
      fontSize: 7.5,
      bold: index === 0 || !!col.bold,
      alignment: col.align || 'left',
      color: index === 0 && selected ? '#00A650' : '#0F172A'
    }))
  })
  return [
    {
      text: title,
      fontSize: 8,
      bold: true,
      color: '#475569',
      characterSpacing: 0.8,
      margin: [0, 0, 0, 4]
    },
    {
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: columns.map((col) => col.width || '*'),
        body: [header, ...body]
      },
      margin: [0, 0, 0, 10],
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0,
        hLineColor: () => '#E2E8F0',
        paddingLeft: () => 6,
        paddingRight: () => 6,
        paddingTop: () => 3,
        paddingBottom: () => 3
      }
    }
  ]
}
